class s extends Error {
  constructor(e) {
    super(e), this.name = this.constructor.name;
  }
}
export {
  s as FailedDependency
};
